import { createSlice } from "@reduxjs/toolkit";

//CONSTANTS
export const SELECTED_ICON = "selectedIcon";
export const OBJECT_CATEGORY = "objectCategory";
export const EXPANDED = "expanded";
export const ACC_TOP_FOLDERS = "accTopFolders";
export const SELECTED_TREE_ITEMS = "selectedTreeItems";
export const SELECTED_SCHEDULE = "selectedSchedule";

//INITIAL STATE OBJECT
const initialState = {
  [SELECTED_ICON]: "",
  [OBJECT_CATEGORY]: "",
  [EXPANDED]: [],
  [ACC_TOP_FOLDERS]: [],
  [SELECTED_TREE_ITEMS]: [],
  [SELECTED_SCHEDULE]: "Valves",
};

export const navigationSlice = createSlice({
  name: "navigationReducer",
  initialState: initialState,
  reducers: {
    updateNavigationState: (state, action) => {
      // state[action.payload.stateName] = action.payload.value;
      return {
        ...state,
        [action.payload.stateName]: action.payload.value,
      };
    },
  },
});

export const { updateNavigationState } = navigationSlice.actions;

export const navigationReducer = navigationSlice.reducer;
